import { render } from "./LegalIcon.vue?vue&type=template&id=c5f7294c&ts=true"
import script from "./LegalIcon.vue?vue&type=script&lang=ts"
export * from "./LegalIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__